<script>
	import { getContext } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { slide } from 'svelte/transition'
	import { upload_social } from '../library/scripts/fileUploader'
	import { getCookie } from '../library/scripts/cookie'
	import {
		storeActiveBlock,
		storeShowFinishedBlocks,
		storeShowCreateButtons,
		storeData,
		storeFinishedContent,
		storeSocial,
	} from '../library/scripts/Store.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'

	const globals = getContext('globals')
	const colorMain = globals.adminColorMain
	const fsXS = globals.fsXS
	const buttonBgHover = globals.adminButtonBgHover
	const fsN = globals.fsN
	const fsL = globals.fsL
	const fsS = globals.fsS

	let sendObject = false

	// the url of social medias
	let facebook, instagram, telegram, youtube, linkedin, twitter

	// finished content
	let finishedContent = $storeFinishedContent

	// if social media is set in config, we add the links
	if ($storeData && $storeData.social) {
		$storeData.social.forEach((soc) => {
			switch (soc.name) {
				case 'facebook':
					facebook = soc.link
					break

				case 'instagram':
					instagram = soc.link
					break

				case 'telegram':
					telegram = soc.link
					break

				case 'youtube':
					youtube = soc.link
					break

				case 'linkedin':
					linkedin = soc.link
					break

				case 'twitter':
					twitter = soc.link
					break
			}
		})
	}

	// get the id
	const ID = getCookie('id')

	const close_window = () => {
		const toWait = setTimeout(() => {
			storeShowFinishedBlocks.set(true)
			storeShowCreateButtons.set(true)
			storeActiveBlock.set(null)
			storeSocial.set(false)
			clearTimeout(toWait)
		}, 500)
		storeSocial.set(true)
	}

	const save_block = () => {
		sendObject = true
		let social = []
		if (facebook) social.push({ name: 'facebook', link: facebook })
		if (instagram) social.push({ name: 'instagram', link: instagram })
		if (telegram) social.push({ name: 'telegram', link: telegram })
		if (youtube) social.push({ name: 'youtube', link: youtube })
		if (linkedin) social.push({ name: 'linkedin', link: linkedin })
		if (twitter) social.push({ name: 'twitter', link: twitter })

		const upload = upload_social(ID, social)
		upload.then((value) => {
			if (value) {
				sendObject = false
				close_window()
			}
		})
	}
</script>

{#if $storeSocial}
	<main id="social_div" use:styles={{ colorMain, fsN }} transition:slide={{ duration: 500 }}>
		{#if $storeActiveBlock}
			<div class="block_title" use:styles={{ fsL, colorMain }}>social media</div>
			<div class="info" use:styles={{ fsS, colorMain }}>
				Log in to the relevant account and copy the internet address,then paste the address into the appropriate field.
				<br />For X(twitter) account, follow these instructions:
				<a href="https://help.twitter.com/en/using-x/add-follow-button-to-website" rel="noreferrer" target="_blank"
					>x-instructions</a
				>
			</div>
			<div class="container">
				<div class="small_row">
					<div class="button_left" data-fb />
					<input type="text" bind:value={facebook} placeholder="url facebook" />
				</div>
				<!-- <div class="small_row">
					<div class="button_left" data-insta />
					<input type="text" bind:value={instagram} placeholder="url instagram" />
				</div> -->
				<div class="small_row">
					<div class="button_left" data-x />
					<input type="text" bind:value={twitter} placeholder="url x (twitter)" />
				</div>
				<!-- <div class="small_row">
					<div class="button_left" data-tele />
					<input type="text" bind:value={telegram} placeholder="url telegram" />
				</div> -->
				<div class="small_row">
					<div class="button_left" data-linked />
					<input type="text" bind:value={linkedin} placeholder="url linkedin" />
				</div>
				<div class="small_row">
					<div class="button_left" data-youtube />
					<input type="text" bind:value={youtube} placeholder="url youtube" />
				</div>
			</div>
			<div class="button_container">
				<button on:click={close_window} use:styles={{ colorMain, fsXS, buttonBgHover }}>close</button>

				<button on:click={save_block} use:styles={{ colorMain, fsXS, buttonBgHover }}>save</button>
			</div>
		{/if}
	</main>
{/if}

{#if sendObject}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" size={fsS} fontSize={fsXS} info="upload social links" />
		</div>
	</Shader>
{/if}

<style>
	a {
		color: white;
	}
	a:hover {
		color: burlywood;
	}
	main {
		width: 95vw;
		display: flex;
		flex-direction: column;
		padding: 2%;
		color: var(--colorMain);
		font-size: var(--fsN);
		user-select: none;
	}

	input[type='text'] {
		background-color: var(--inputBg);
		color: var(--colorMain);
		width: 90%;
		font-size: var(--fsS);
		border: 1px solid green;
	}

	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.container {
		display: flex;
		flex-direction: column;
		padding: 5%;
	}

	.small_row {
		display: grid;
		grid-template-columns: 10% 60%;
		align-items: center;
		column-gap: 20px;
		margin-bottom: 20px;
	}

	.info {
		font-size: var(--fsS);
		color: var(--colorMain);
	}

	[data-fb] {
		width: clamp(15px, 2vw, 30px);
		height: clamp(15px, 2vw, 30px);
		background-image: url('/images/facebook.svg');
		background-size: cover;
	}

	/* [data-insta] {
		width: clamp(15px, 2vw, 30px);
		height: clamp(15px, 2vw, 30px);
		background-image: url('/images/instagram.svg');
		background-size: cover;
	} */

	[data-x] {
		width: clamp(15px, 2vw, 30px);
		height: clamp(15px, 2vw, 30px);
		background-image: url('/images/twitter.svg');
		background-size: cover;
	}

	[data-youtube] {
		width: clamp(15px, 2vw, 30px);
		height: clamp(15px, 2vw, 30px);
		background-image: url('/images/youtube.svg');
		background-size: cover;
	}

	[data-linked] {
		width: clamp(15px, 2vw, 30px);
		height: clamp(15px, 2vw, 30px);
		background-image: url('/images/linkedin.svg');
		background-size: cover;
	}

	/* [data-tele] {
		width: clamp(15px, 2vw, 30px);
		height: clamp(15px, 2vw, 30px);
		background-image: url('/images/telegram.svg');
		background-size: cover;
	} */

	.button_left {
		justify-content: flex-start;
	}

	.block_title {
		color: var(--colorMain);
		font-size: var(--fsL);
		text-transform: uppercase;
		font-weight: bold;
		margin: 20px 0px 20px 0px;
	}
</style>
